import { User, Desk, Room, Reservation, FloorPlan, SeatStatus, Facility } from "../types";

// --- MOCK DATABASE (Generated from updated XML floor plan) ---
let users: User[] = []; // Start with an empty user list
let reservations: Reservation[] = []; // Start with empty reservations
 
const rooms: Room[] = [
  { id: '2004', position: { x: 10, y: 699 }, size: { width: 320, height: 420 } },
  { id: '2005', position: { x: 330, y: 699 }, size: { width: 320, height: 420 } },
  { id: '2025', position: { x: 2810, y: 749 }, size: { width: 300, height: 420 } },
  { id: '2026', position: { x: 3110, y: 749 }, size: { width: 300, height: 420 } },
  { id: '2027', position: { x: 3410, y: 749 }, size: { width: 390, height: 420 } },
  { id: '2028', position: { x: 3800, y: 749 }, size: { width: 390, height: 420 } },
  { id: '2021', position: { x: 3900, y: 149 }, size: { width: 300, height: 430 } },
  { id: '2022', position: { x: 3520, y: 149 }, size: { width: 380, height: 430 } },
  { id: '2017', position: { x: 2490, y: 59 }, size: { width: 300, height: 430 } },
  { id: '2016', position: { x: 2050, y: 59 }, size: { width: 440, height: 430 } },
  { id: '2015', position: { x: 1580, y: 59 }, size: { width: 470, height: 430 } },
  { id: '2039', position: { x: 5050, y: 129 }, size: { width: 300, height: 430 } },
  { id: '2038', position: { x: 5350, y: 129 }, size: { width: 280, height: 430 } },
  { id: '2036', position: { x: 5630, y: 129 }, size: { width: 380, height: 430 } },
  { id: '2035', position: { x: 6010, y: 129 }, size: { width: 410, height: 430 } },
  { id: '2034', position: { x: 5910, y: 729 }, size: { width: 520, height: 420 } },
  { id: '2033', position: { x: 5530, y: 729 }, size: { width: 380, height: 420 } },
  { id: '2010', position: { x: 1060, y: 699 }, size: { width: 410, height: 420 } },
  { id: '2006', position: { x: 650, y: 699 }, size: { width: 410, height: 420 } },
  { id: '2003', position: { x: 14, y: 59 }, size: { width: 426, height: 435 } },
  { id: '2002', position: { x: 440, y: 59 }, size: { width: 410, height: 430 } },
  { id: '2011', position: { x: 1470, y: 699 }, size: { width: 410, height: 420 } },
  { id: '2012', position: { x: 1880, y: 699 }, size: { width: 360, height: 420 } },
  { id: '2013', position: { x: 2240, y: 699 }, size: { width: 560, height: 420 } }
];

const facilities: Facility[] = [
  { id: 'facility-1', name: 'Stairs', type: 'stairs', position: { x: 2830, y: 149 }, size: { width: 490, height: 220 } },
  { id: 'facility-2', name: 'Stairs', type: 'stairs', position: { x: 4420, y: 199 }, size: { width: 210, height: 330 } },
  { id: 'facility-3', name: 'Stairs', type: 'stairs', position: { x: 1280, y: 69 }, size: { width: 290, height: 420 } },
  { id: 'facility-4', name: 'Küche', type: 'kitchen', position: { x: 3320, y: 149 }, size: { width: 200, height: 430 } },
  { id: 'facility-5', name: 'Aufzug', type: 'elevator', position: { x: 4200, y: 189 }, size: { width: 220, height: 335 } },
  { id: 'facility-6', name: 'Aufzug', type: 'elevator', position: { x: 4630, y: 199 }, size: { width: 210, height: 335 } },
  { id: 'facility-7', name: 'Aufzug', type: 'elevator', position: { x: 3140, y: 369 }, size: { width: 180, height: 210 } },
  { id: 'facility-8', name: 'Küche', type: 'kitchen', position: { x: 4834, y: 129 }, size: { width: 216, height: 430 } },
  { id: 'facility-9', name: 'Meeting', type: 'meeting', position: { x: 4840, y: 729 }, size: { width: 690, height: 420 } }
];

const desks: Desk[] = [
  { id: 'dsk1', name: '2004-1', room: '2004', location: 'left window' },
  { id: 'dsk2', name: '2004-2', room: '2004', location: 'right window' },
  { id: 'dsk3', name: '2005-1', room: '2005', location: 'left window' },
  { id: 'dsk4', name: '2005-2', room: '2005', location: 'right window' },
  { id: 'dsk5', name: '2025-1', room: '2025', location: 'left window' },
  { id: 'dsk6', name: '2025-2', room: '2025', location: 'right window' },
  { id: 'dsk7', name: '2026-1', room: '2026', location: 'left window' },
  { id: 'dsk8', name: '2026-2', room: '2026', location: 'right window' },
  { id: 'dsk9', name: '2027-1', room: '2027', location: 'left window' },
  { id: 'dsk10', name: '2027-2', room: '2027', location: 'right window' },
  { id: 'dsk11', name: '2027-3', room: '2027', location: 'left' },
  { id: 'dsk12', name: '2028-1', room: '2028', location: 'left window' },
  { id: 'dsk13', name: '2028-2', room: '2028', location: 'right window' },
  { id: 'dsk14', name: '2028-3', room: '2028', location: 'left' },
  { id: 'dsk15', name: '2021-1', room: '2021', location: 'right' },
  { id: 'dsk16', name: '2022-1', room: '2022', location: 'right' },
  { id: 'dsk17', name: '2022-2', room: '2022', location: 'left' },
  { id: 'dsk18', name: '2017-1', room: '2017', location: 'right' },
  { id: 'dsk19', name: '2016-1', room: '2016', location: 'right' },
  { id: 'dsk20', name: '2016-2', room: '2016', location: 'left' },
  { id: 'dsk21', name: '2016-3', room: '2016', location: 'left window' },
  { id: 'dsk22', name: '2015-1', room: '2015', location: 'right' },
  { id: 'dsk23', name: '2015-2', room: '2015', location: 'left' },
  { id: 'dsk24', name: '2015-3', room: '2015', location: 'left window' },
  { id: 'dsk25', name: '2015-4', room: '2015', location: 'right window' },
  { id: 'dsk26', name: '2039-1', room: '2039', location: 'right' },
  { id: 'dsk27', name: '2039-2', room: '2039', location: 'left' },
  { id: 'dsk28', name: '2038-1', room: '2038', location: 'right' },
  { id: 'dsk29', name: '2038-2', room: '2038', location: 'left' },
  { id: 'dsk30', name: '2036-1', room: '2036', location: 'right' },
  { id: 'dsk31', name: '2036-2', room: '2036', location: 'left' },
  { id: 'dsk32', name: '2035-1', room: '2035', location: 'right' },
  { id: 'dsk33', name: '2035-2', room: '2035', location: 'left' },
  { id: 'dsk34', name: '2034-1', room: '2034', location: 'left' },
  { id: 'dsk35', name: '2034-2', room: '2034', location: 'right window' },
  { id: 'dsk36', name: '2034-3', room: '2034', location: 'left window' },
  { id: 'dsk37', name: '2034-4', room: '2034', location: 'right' },
  { id: 'dsk38', name: '2033-1', room: '2033', location: 'left window' },
  { id: 'dsk39', name: '2033-2', room: '2033', location: 'right window' },
  { id: 'dsk40', name: '2010-1', room: '2010', location: 'right window' },
  { id: 'dsk41', name: '2010-2', room: '2010', location: 'left window' },
  { id: 'dsk42', name: '2006-1', room: '2006', location: 'left window' },
  { id: 'dsk43', name: '2006-2', room: '2006', location: 'right window' },
  { id: 'dsk44', name: '2006-3', room: '2006', location: 'right' },
  { id: 'dsk45', name: '2003-1', room: '2003', location: 'right' },
  { id: 'dsk46', name: '2003-2', room: '2003', location: 'left' },
  { id: 'dsk47', name: '2003-3', room: '2003', location: 'left window' },
  { id: 'dsk48', name: '2002-1', room: '2002', location: 'right' },
  { id: 'dsk49', name: '2002-2', room: '2002', location: 'left' },
  { id: 'dsk50', name: '2002-3', room: '2002', location: 'left window' },
  { id: 'dsk51', name: '2011-1', room: '2011', location: 'left window' },
  { id: 'dsk52', name: '2011-2', room: '2011', location: 'right window' },
  { id: 'dsk53', name: '2011-3', room: '2011', location: 'left' },
  { id: 'dsk54', name: '2012-1', room: '2012', location: 'right window' },
  { id: 'dsk55', name: '2012-2', room: '2012', location: 'left window' },
  { id: 'dsk56', name: '2013-1', room: '2013', location: 'left window' },
  { id: 'dsk57', name: '2013-2', room: '2013', location: 'left' },
  { id: 'dsk58', name: '2013-3', room: '2013', location: 'right window' },
  { id: 'dsk59', name: '2013-4', room: '2013', location: 'right' }
];

// NEW FUNCTION
export const findOrCreateUserByName = async (name: string): Promise<User> => {
  await sleep(100);
  let user = users.find(u => u.name.toLowerCase() === name.toLowerCase());
  
  if (user) {
    return { ...user };
  } else {
    const newUser: User = {
      id: `user-${Date.now()}`,
      name: name,
      email: `${name.replace(/\s+/g, '.').toLowerCase()}@corp.com`,
      defaultDeskId: null,
      defaultWeekdays: [],
      autoReserveEnabled: false,
    };
    users.push(newUser);
    return { ...newUser };
  }
};

export const updateUser = async (updatedUser: User): Promise<User> => {
  await sleep(200);
  const userIndex = users.findIndex(u => u.id === updatedUser.id);
  if (userIndex !== -1) {
    // If the name is changed, we need to handle potential conflicts
    const nameExists = users.some(u => u.name.toLowerCase() === updatedUser.name.toLowerCase() && u.id !== updatedUser.id);
    if(nameExists) {
        throw new Error("This name is already taken by another user.");
    }
    users[userIndex] = { ...users[userIndex], ...updatedUser };
    return { ...users[userIndex] };
  }
  throw new Error("User not found");
};

function getNextDayOfWeek(date: Date, dayOfWeek: number): Date {
  const resultDate = new Date(date.getTime());
  const currentDay = resultDate.getDay();
  const distance = (dayOfWeek + 7 - currentDay) % 7;
  resultDate.setDate(resultDate.getDate() + distance + (distance === 0 ? 7 : 0) );
  return resultDate;
}

const generateFloorPlan = (): FloorPlan => {
  const allElements = [...rooms, ...facilities];
  const allX = allElements.map(r => [r.position.x, r.position.x + r.size.width]).flat();
  const allY = allElements.map(r => [r.position.y, r.position.y + r.size.height]).flat();
  
  const minX = Math.min(...allX);
  const minY = Math.min(...allY);
  const maxX = Math.max(...allX);
  const maxY = Math.max(...allY);
  
  return {
    planId: "full-floor-plan-v3", // Version bump
    planName: "Main Office Floor (Corrected)",
    dimensions: { minX, minY, width: maxX - minX, height: maxY - minY, },
    rooms,
    facilities,
    desks,
  };
};

const floorPlan = generateFloorPlan();
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const getCurrentUser = async (): Promise<User> => {
  await sleep(100);
  return { ...users[0] };
}; 
export const getDesks = async (): Promise<Desk[]> => {
  await sleep(200);
  return desks;
};

export const getReservationsForUser = async (user: User): Promise<Reservation[]> => {
  await sleep(150);
  // Manual reservations are now filtered by the dynamic user's ID
  let finalReservations = reservations.filter(r => r.userId === user.id);

  if (!user.autoReserveEnabled || !user.defaultDeskId) {
    return finalReservations;
  } 

  const autoGeneratedReservations: Reservation[] = [];
  const today = new Date();
  
  for (let i = 0; i < 30; i++) { // Generate for the next 30 days
    const futureDate = new Date();
    futureDate.setDate(today.getDate() + i);
    const dayOfWeek = futureDate.getDay();
    
    if (user.defaultWeekdays.includes(dayOfWeek)) {
      const dateString = futureDate.toISOString().split('T')[0];
      const hasManualBookingForDay = finalReservations.some(r => r.date === dateString);
      
      if (!hasManualBookingForDay) {
        autoGeneratedReservations.push({
          id: `res-auto-${dateString}`,
          userId: user.id,
          deskId: user.defaultDeskId,
          date: dateString,
        });
      }
    }
  }
  return [...finalReservations, ...autoGeneratedReservations];
};

export const getAllReservations = async (): Promise<Reservation[]> => {
  await sleep(300);
  return reservations;
};

export const addReservation = async (userId: string, deskId: string, date: string): Promise<Reservation> => {
  await sleep(400);
  // Remove any existing reservation for this user on this date
  reservations = reservations.filter(r => !(r.userId === userId && r.date === date));
  const newReservation: Reservation = { id: `res${Date.now()}`, userId, deskId, date, };
  reservations.push(newReservation);
  return newReservation;
};

export const cancelReservation = async (reservationId: string): Promise<void> => {
  await sleep(400);
  if (reservationId.startsWith('res-auto-')) {
      return;
  }
  reservations = reservations.filter(r => r.id !== reservationId);
};

export const getLayoutData = async (planId: string): Promise<FloorPlan> => {
  await sleep(200);
  return floorPlan;
};

export const getSeatStatus = async (planId: string, date: string): Promise<SeatStatus[]> => {
  await sleep(150);
  const allReservationsForDate = reservations.filter(r => r.date === date);

  // This is a complex operation, we need to generate all auto-reservations to get a complete status
  let allActiveReservations = [...allReservationsForDate];
  for (const user of users) {
      if (user.autoReserveEnabled && user.defaultDeskId) {
          const hasManualBooking = allReservationsForDate.some(r => r.userId === user.id);
          const dateObj = new Date(date + 'T00:00:00');
          if (!hasManualBooking && user.defaultWeekdays.includes(dateObj.getDay())) {
              allActiveReservations.push({
                  id: `res-auto-${date}`,
                  userId: user.id,
                  deskId: user.defaultDeskId,
                  date: date
              });
          }
      }
  }

  const reservedForDate = new Set(allActiveReservations.map(r => r.deskId));

  return desks.map(desk => ({
    seatId: desk.id,
    status: reservedForDate.has(desk.id) ? 'booked' : 'available',
  }));
};